import React, { useEffect, useState } from 'react'
import { Routes, Route } from "react-router-dom";
import SignIn from './SignIn';
import Signup from './Signup';
import './Auth.scss'
import ForgetPassword from './ForgetPassword';
import NotFoundPage from '../Components/NotFoundPage';
import ValidateOtp from './ValidateOtp';
import foreseeLogo from '../NovaWidget/assets/foresee-eagle.png';

function Index() {
    const [isCollapsed, setIsCollapsed] = useState(true);
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsCollapsed(false);
        }, 1000); // Show splash for 3 seconds

        return () => clearTimeout(timer);
    }, []);

    const isOtpAllowed = () => {
        const otpFlow = sessionStorage.getItem("is_otp_allowed");
        // 'signup' or 'forgot'
        return otpFlow === "signup" || otpFlow === "forgot" || otpFlow === "/";
    };


    const getRedirectPath = () => {
        const sourcePage = sessionStorage.getItem("otp_source_page");
        if (sourcePage === "/sign-up") return "/sign-up";
        if (sourcePage === "/forget-password") return "/forget-password";
        return "/";
    };
    // const isOtpAllowed = () => sessionStorage.getItem('is_otp_allowed') === 'true';
    return (
        <div className='sign-in-container'>
            {isCollapsed ?
                <div className="logo-panel">
                    <div className="lg-clouds" aria-hidden="true">
                        <div className="lg-cloud lg-cloud--far">
                            <svg width="2000" height="1080" viewBox="0 0 2000 1080">
                                <filter id="sp-cf" filterUnits="userSpaceOnUse" x="0" y="0" width="2000" height="1080" colorInterpolationFilters="sRGB">
                                    <feTurbulence type="fractalNoise" baseFrequency="0.0016 0.0062" numOctaves={5} seed={4} stitchTiles="stitch"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  3.4 0 0 0 -1.45"/>
                                </filter>
                                <rect width="2000" height="1080" filter="url(#sp-cf)"/>
                            </svg>
                        </div>
                        <div className="lg-cloud lg-cloud--near">
                            <svg width="2000" height="1080" viewBox="0 0 2000 1080">
                                <filter id="sp-cn" filterUnits="userSpaceOnUse" x="0" y="0" width="2000" height="1080" colorInterpolationFilters="sRGB">
                                    <feTurbulence type="fractalNoise" baseFrequency="0.0024 0.0078" numOctaves={6} seed={11} stitchTiles="stitch"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  3.8 0 0 0 -1.62"/>
                                    <feGaussianBlur stdDeviation="1.2"/>
                                </filter>
                                <rect width="2000" height="1080" filter="url(#sp-cn)"/>
                            </svg>
                        </div>
                    </div>
                    <div className="splash-brand">
                        <img src={foreseeLogo} alt="Foresee Security" className="splash-brand-logo" />
                        <div className="splash-brand-text">
                            <span className="splash-brand-name">FORESEE</span>
                            <span className="splash-brand-sub">SECURITY</span>
                        </div>
                    </div>
                </div> :
                <div
                    className="auth-panel"
                >
                    <Routes>
                        <Route index element={<SignIn />} />
                        <Route path="/sign-up" element={<Signup />} />
                        <Route path="/forget-password" element={<ForgetPassword />} />
                        <Route
                            path="/otp-verification"
                            element={
                                <ValidateOtp />
                            }
                        />
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>

                </div>
            }
        </div>
    )
}

export default Index;